import '../../App.css';
import React, { useContext, useEffect, useCallback, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import ModalCadastrarUsuario from '../../components/modal/ModalCadastrarUsuario'
import { ColumnDirective, ColumnsDirective, GridComponent, Inject, Page, Toolbar, Sort } from '@syncfusion/ej2-react-grids';
import { L10n } from '@syncfusion/ej2-base';
import { FaPlus } from 'react-icons/fa'
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import moment from 'moment/moment';
import 'moment/locale/pt-br'
import ModalTrocarRole from '../../components/modal/ModalTrocarRole';
import { TbPencil } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import { PermissoesContext } from '../../context/PermissoesContext';
import LoadingScreen from '../../components/LoadingScreen';
import Tabela from '../../components/Tabela';

function CadastroUsuario() {
    const { Success, Error, openModal, setOpenModal, UsuariosConsulta, ListaUsuariosConsulta, loading, TrocarRoleModal, setModalTrocarRole, setIdUser, setNomeUser, setEmailUser, setAdminUser, setSupervisorUser, setLeitorUser, Permissao, StatusUsuario, ListaFiltroUsuario, totalRegistrosUsuario, filtroUsuario, totalRegistrosFiltroUsuario } = useContext(ApiContext)
    const { ListarMenu, ListarMenuUsuario } = useContext(PermissoesContext)
    const { h3Demanda, btnCriar, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");


    // const verificaUsuario = (props) => {
    //     if (props.admin) {
    //         return "Admin"
    //     }
    //     else if (props.supervisor) {
    //         return "Supervisor"
    //     }
    //     else if (props.somenteVisualizar) {
    //         return "Leitor"
    //     }
    //     else {
    //         return "Outro"
    //     }
    // }

    const editarRole = async (id, nome, email, admin, supervisor, leitor) => {
        setIdUser(id)
        setNomeUser(nome)
        setEmailUser(email)
        setAdminUser(admin)
        setSupervisorUser(supervisor)
        setLeitorUser(leitor)

        await ListarMenuUsuario(id)
        setModalTrocarRole(true)
    }

    useEffect(() => {
        ListarMenu()
    }, [])

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroUsuario(searchTerm, currentPage, pageSize);
        } else {
            ListaUsuariosConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroUsuario : totalRegistrosUsuario;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <div>
            <Header pagina={'Cadastros'} subpagina={'Cadastrar usuário'}></Header>
            <MenuLateral></MenuLateral>
            {TrocarRoleModal &&
                <ModalTrocarRole />
            }
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            {loading && <LoadingScreen />}
            <div className='container-principal'>
                <div className='demanda-header'>
                    {openModal &&
                        <ModalCadastrarUsuario closeModal={setOpenModal} />
                    }
                    <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setOpenModal(true)}><FaPlus style={{ marginRight: "10px" }} />Cadastrar usuário</button>
                </div>
                <div className='card card-table'>
                    <h3 className='h3-demanda' style={h3Demanda}>Usuários cadastrados</h3>
                    <Tabela
                        data={searchTerm.trim() !== "" ? filtroUsuario : UsuariosConsulta}
                        columns={[
                            { label: "Nome", field: "nome", width: "40%" },
                            { label: "E-mail", field: "email", width: "40%", render: (x) => x.email || "-" },
                            {
                                label: "Ativo",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                        <input type="checkbox" label=" Ativo" className="toggleBtn" onChange={() => StatusUsuario(x.id, !x.ativo, currentPage)} checked={x.ativo} />
                                    </div>
                                ),
                            },
                            { label: "Último login", field: "ultimoLogin", width: "40%", render: (x) => moment(x.ultimoLogin).format("DD/MM/YYYY HH:mm") || "-" },
                            {
                                label: "Opções",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <button onClick={() => editarRole(x.id, x.nome, x.email, x.admin, x.supervisor, x.leitor)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                            <TbPencil />
                                        </button>
                                    </div>
                                ),
                            },
                        ]}
                        loading={loading}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        setCurrentPage={setCurrentPage}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        onSearch={(term) => {
                            setCurrentPage(1);
                            if (term.trim() !== "") {
                                ListaFiltroUsuario(term, 1, 10);
                            } else {
                                ListaUsuariosConsulta(1, 10);
                            }
                        }}
                        corTerciaria={corTerciaria}
                    />
                </div>
            </div>
            <Footer></Footer>
        </div>
    );
}

export default CadastroUsuario;